import { inject } from '@angular/core'
import { CanActivateFn, Router, Routes } from '@angular/router'
import { filter, map, mergeMap } from 'rxjs'
import { BaseLayoutComponent } from './layout/base-layout/base-layout.component'
import { AppsComponent } from './pages/apps/apps.component'
import { CastComponent } from './pages/cast/cast.component'
import { ChannelComponent } from './pages/channel/channel.component'
import { HomeComponent } from './pages/home/home.component'
import { RegisterComponent } from './pages/register/register.component'
import { StateService } from './services/state.service'
import { ExternalLinkComponent } from './pages/external-link/external-link.component'
import { ErrorComponent } from './pages/error/error.component'
import { TestComponent } from './pages/test/test.component'
import { LanguageSelectorComponent } from './layout/components/language-selector/language-selector.component'
import { ProgramGuideComponent } from './pages/program-guide/program-guide.component'
import { WakeUpAlarmComponent } from './pages/wake-up-alarm/wake-up-alarm.component'
import { AlarmRingingComponent } from './pages/alarm-ringing/alarm-ringing.component'
import { CastDongleComponent } from './pages/cast/cast-dongle/cast-dongle.component'
import { LegacyChannelGridComponent } from './pages/legacy-channel-grid/legacy-channel-grid.component'
import { HdmiComponent } from './pages/hdmi/hdmi.component'
import { VODComponent } from './pages/vod/vod.component'
import { VODCatalogComponent } from './pages/vod-catalog/vod-catalog.component'
import { HdmiNotFoundComponent } from './pages/hdmi-not-found/hdmi-not-found.component'

const registerGuard: CanActivateFn = () => {
  const stateService = inject(StateService)
  const router = inject(Router)
  return stateService.isLoading$.pipe(
    filter(isLoading => !isLoading),
    mergeMap(() => stateService.isRegistered$),
    map(isRegistered => {
      if (!isRegistered) {
        router.navigate(['/register'])
      }
      return isRegistered
    })
  )
}

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [registerGuard],
    children: [
      {
        path: 'cast',
        component: CastComponent,
      },
      {
        path: 'cast-dongle',
        component: CastDongleComponent,
      },
      {
        path: 'channel',
        component: ChannelComponent,
      },
      {
        path: 'external-link',
        component: ExternalLinkComponent,
      },
      {
        path: 'hdmi',
        component: HdmiComponent,
      },
      {
        path: 'hdmi-not-found',
        component: HdmiNotFoundComponent,
      },
      {
        path: 'vod',
        component: VODComponent,
      },
      {
        path: '',
        component: BaseLayoutComponent,
        children: [
          {
            path: '',
            component: HomeComponent,
          },
          {
            path: 'page/:id',
            component: HomeComponent,
          },
          {
            path: 'apps',
            component: AppsComponent,
          },
          {
            path: 'channel-grid',
            component: LegacyChannelGridComponent,
          },
          {
            path: 'language',
            component: LanguageSelectorComponent,
          },
          {
            path: 'program-guide',
            component: ProgramGuideComponent,
          },
          {
            path: 'vod-catalog',
            component: VODCatalogComponent,
          },
          {
            path: 'wake-up-alarm',
            component: WakeUpAlarmComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'alarm-ringing',
    component: AlarmRingingComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'test',
    component: TestComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
]
